<div class="container-fluid">
  <div class="row m-row">
    <div class="col-lg-6 p-3 slider-container">
      <div class="right-panel">
        <div class="right-panel-head p-3">
          <div class="dropdown">
            <button
              class="btn btn-default dropdown-toggle lang-dropdown"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ currentLanguage === 'ar' ? 'العربية' : 'English' }}
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" (click)="changeLanguage('en-US')"
                >English</a
              >
              <a class="dropdown-item" (click)="changeLanguage('ar')"
                >العربية</a
              >
            </div>
          </div>
        </div>
        <app-splash-screen-sliders
          [isWhiteBackground]="false"
        ></app-splash-screen-sliders>
      </div>
    </div>

    <div class="col-lg-6 main-content">
      <div class="main-header">
        <div class="d-flex justify-content-between">
          @if (contactInfo) {
            <div class="contact-div mt-3 pt-2" [dir]="dir">
              <button mat-stroked-button [matMenuTriggerFor]="userMenu">
                <mat-icon
                  fontSet="material-icons-outlined"
                  class="text-secondary"
                  >help</mat-icon
                >
                <span translate class="text-secondary">Contact Us</span>
              </button>
              <mat-menu #userMenu="matMenu">
                <a
                  mat-menu-item
                  href="tel:{{ contactInfo.supportNumber | numberTranslate }}"
                  class="text-left"
                  dir="ltr"
                  translate
                >
                  <mat-icon>phone</mat-icon>
                  <span dir="ltr">{{
                    contactInfo.supportNumber | numberTranslate
                  }}</span>
                </a>
                <a
                  mat-menu-item
                  href="mailto:{{ contactInfo.supportEmail }}"
                  class="text-left"
                  dir="ltr"
                  translate
                >
                  <mat-icon>email</mat-icon>
                  {{ contactInfo.supportEmail }}
                </a>
              </mat-menu>
            </div>
          }
          <div class="language-div mt-3 pt-2">
            <app-language-selector [icon]="true"></app-language-selector>
          </div>
        </div>
      </div>

      <!-- Login user name and password -->
      @if (state === 1) {
        <div class="form-div">
          <div class="text-center">
            <img
              class="logo-img"
              [src]="'assets/flyplus/app-logo.svg' | assets"
              alt=""
            />
          </div>
          <div class="mt-5 text-center">
            <h5 class="fw-700" translate>Login your account</h5>
          </div>
          <form
            dir="{{ htmlTag.dir }}"
            (ngSubmit)="login()"
            [formGroup]="loginForm"
            novalidate
            appTrackForm
          >
            <div class="login-error" [hidden]="!error || isLoading" translate>
              Username or password incorrect.
            </div>
            <div
              class="deactivated-banner"
              *ngIf="isAccountDeactivated && !isLoading"
            >
              <mat-icon class="banner-icon">warning_amber</mat-icon>
              <span>
                {{ 'account.deactivated.loginBanner' | translate }}
                <a
                  class="reactivate-link"
                  [routerLink]="['/reactivate']"
                  [queryParams]="{ email: loginForm.get('username').value }"
                  >{{ 'account.reactivate.reactivateNow' | translate }}</a
                >
              </span>
            </div>
            <br />
            <div class="login-fields d-flex flex-column">
              <mat-label translate>Email / Phone Number</mat-label>
              <mat-form-field
                [hideRequiredMarker]="true"
                appearance="outline"
                subscriptSizing="dynamic"
              >
                <input
                  type="text"
                  matInput
                  formControlName="username"
                  autocomplete="username"
                  [placeholder]="'Email or Phone Number' | translate"
                  required
                />
                <mat-hint class=""
                  ><span translate>Hint:</span>
                  <span>{{
                    'username_hint'
                      | translate
                        : {
                            email: 'user@example.com',
                            phone: country.code + 'XXXXXXXXX' | numberTranslate,
                          }
                  }}</span>
                </mat-hint>
                <mat-error>
                  @if (loginForm.get('username')?.hasError('required')) {
                    <span translate>Email or phone number is required</span>
                  } @else {
                    <span translate>Enter a valid email or phone number</span>
                  }
                </mat-error>
              </mat-form-field>
              <mat-label translate>Password</mat-label>
              <mat-form-field
                class="password-field"
                [hideRequiredMarker]="true"
                appearance="outline"
                subscriptSizing="dynamic"
              >
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  matInput
                  formControlName="password"
                  autocomplete="current-password"
                  [placeholder]="'Password' | translate"
                  required
                />
                <mat-icon (click)="showHidePassword()" matSuffix>{{
                  showPassword ? 'visibility' : 'visibility_off'
                }}</mat-icon>
                <mat-error>
                  <span translate>Password is required</span>
                </mat-error>
              </mat-form-field>
              <a
                class="mb-4 align-self-end mr-2 fs-13"
                [href]="'/forgotPassword'"
              >
                <span translate>Forgot Password?</span>
              </a>
              <button
                mat-flat-button
                color="primary"
                type="submit"
                [disabled]="loginForm.invalid || isLoading"
                appTrackClick="login-login-btn"
                ctaType="primary"
              >
                <app-loader
                  class="inline-loader"
                  [isLoading]="isLoading"
                ></app-loader>
                <span translate>Login</span>
              </button>
            </div>
          </form>
          <div class="text-center fs-13 fw-400 my-3">
            <span translate>Don’t have an account?</span>
            <a href="/register" translate>Sign up</a>
          </div>
          <div class="mt-5 text-center">
            <img
              [src]="'assets/flyplus/powered-by.png' | assets"
              width="130"
              class="mt-5 mb-3"
            />
            <!-- Public Terms & Conditions page, reachable before login (US 43716) -->
            <div>
              <a
                class="terms-link fs-13"
                routerLink="/terms-and-conditions"
                translate
                >Terms &amp; Conditions</a
              >
            </div>
          </div>
        </div>
      }

      <!-- OTP choose number -->
      @if (state === 2) {
        <div class="form-div text-center">
          <div class="">
            <img
              class="logo-img"
              [src]="'assets/flyplus/app-logo.svg' | assets"
              alt=""
            />
          </div>
          <div class="mt-5">
            <h5 class="fw-700">Please verify your phone number</h5>
            <p class="sub-label" translate>
              OTP will be sent to the selected number
            </p>
          </div>
          <form
            (ngSubmit)="sendOtp()"
            [formGroup]="otpForm"
            novalidate
            appTrackForm
          >
            <div class="login-fields d-flex flex-column">
              <!-- <p class="field-label m-t-20">Select your phone number</p> -->
              <mat-label translate>Select Phone Number</mat-label>
              <mat-form-field [hideRequiredMarker]="true" appearance="outline">
                <mat-select formControlName="phone" required>
                  @for (phone of phones; track phone) {
                    <mat-option value="{{ phone.phoneNumber }}">
                      {{ phone.phoneNumber }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <br />
              <button
                mat-flat-button
                class="send-otp-btn"
                color="primary"
                type="submit"
                [disabled]="otpForm.invalid || isLoading"
                appTrackClick="login-request-otp-btn"
                ctaType="primary"
              >
                <app-loader
                  class="inline-loader"
                  [isLoading]="isLoading"
                ></app-loader>
                <span translate>Request OTP</span>
              </button>
            </div>
          </form>
          <div class="mt-5 text-center">
            <img
              [src]="'assets/flyplus/powered-by.png' | assets"
              width="130"
              class="mt-5 mb-3"
            />
          </div>
        </div>
      }

      <!-- OTP verify -->
      @if (state === 3) {
        <div class="form-div text-center">
          <div class="">
            <img
              class="logo-img"
              [src]="'assets/flyplus/app-logo.svg' | assets"
              alt=""
            />
          </div>
          <div class="mt-5">
            <h5 class="fw-700">Please verify your phone number</h5>
            <p class="sub-label" translate>
              OTP will be sent to the selected number
            </p>
          </div>
          <form
            (ngSubmit)="verifyOTP()"
            [formGroup]="verifyOtpForm"
            novalidate
            appTrackForm
          >
            <div class="login-error" [hidden]="!error || isLoading" translate>
              OTP code is incorrect.
            </div>
            <br />
            <div class="login-fields d-flex flex-column text-start">
              <mat-label translate>Enter the code we sent to you</mat-label>
              <mat-form-field [hideRequiredMarker]="true" appearance="outline">
                <input
                  type="text"
                  matInput
                  formControlName="code"
                  maxlength="6"
                  required
                />
              </mat-form-field>
              <br />
              <button
                mat-flat-button
                color="primary"
                class="validate-btn"
                type="submit"
                [disabled]="verifyOtpForm.invalid || isLoading"
                appTrackClick="login-verify-otp-btn"
                ctaType="primary"
              >
                <app-loader
                  class="inline-loader"
                  [isLoading]="isLoading"
                ></app-loader>
                <span translate>Verify OTP</span>
              </button>
              <p class="forgot-password">
                <span translate>Didn't receive the OTP yet?</span>
                <a class="resend-otp-link" (click)="resendOtp()" translate
                  >Resend OTP?</a
                >
              </p>
            </div>
          </form>
          <div class="mt-5 text-center">
            <img
              [src]="'assets/flyplus/powered-by.png' | assets"
              width="130"
              class="mt-5 mb-3"
            />
          </div>
        </div>
      }
    </div>
  </div>
</div>
